import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-seller-protection';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Seller Protection - How to Safely Sell on Poshmark</title>
        <meta
          name='description'
          content='Having a retail business in an online platform like Poshmark or other marketplaces such as Depop, Mercari, Amazon, eBay, Facebook marketplace, and the likes is truly rewarding because it lets you generate income from your closet. It is not a secret that many people nowadays, especially with the pandemic, do their shipping in the comforts of their homes; hence online sellers are earning more than ever.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-seller-protection' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-seller-protection' />
        <meta property='og:title' content='Poshmark Seller Protection - How to Safely Sell on Poshmark' />
        <meta
          property='og:description'
          content='Having a retail business in an online platform like Poshmark or other marketplaces such as Depop, Mercari, Amazon, eBay, Facebook marketplace, and the likes is truly rewarding because it lets you generate income from your closet. It is not a secret that many people nowadays, especially with the pandemic, do their shipping in the comforts of their homes; hence online sellers are earning more than ever.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
